document.addEventListener('DOMContentLoaded', () => {
  const galleries = [...document.querySelectorAll('.main-product__gallery')];

  galleries.forEach((gallery) => {
    const track = gallery.querySelector('.main-product__gallery-track');
    if (!track) return;

    const frame = gallery.querySelector('.main-product__gallery-frame');
    const slides = [...track.querySelectorAll('.main-product__gallery-slide')];
    const thumbButtons = [...gallery.querySelectorAll('.main-product__gallery-thumb')];
    const dotButtons = [...gallery.querySelectorAll('.main-product__gallery-dots-btn')];
    if (slides.length === 0) return;

    const swipeThreshold = 40;
    const swipeDirectionLockThreshold = 10;
    let swipeStartX = 0;
    let swipeStartY = 0;
    let swipeDeltaX = 0;
    let isSwiping = false;
    let isHorizontalSwipe = false;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayInterval = 4000;
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let autoplayTimerId = null;

    const thumbsEl = gallery.querySelector('.main-product__gallery-thumbs');
    const collapsedThumbCount = thumbButtons.filter(
      (thumb) => !thumb.classList.contains('main-product__gallery-thumb--extra')
    ).length;

    const setActiveSlide = (index) => {
      activeIndex = index;
      thumbButtons.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
      });
      dotButtons.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });

      if (index >= collapsedThumbCount) {
        thumbsEl?.classList.add('is-expanded');
        scrollThumbIntoRail(index);
      }
    };

    const scrollThumbIntoRail = (index) => {
      const thumb = thumbButtons[index];
      if (!thumbsEl || !thumb) return;

      const railRect = thumbsEl.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();
      const offsetWithinRail = thumbRect.top - railRect.top + thumbsEl.scrollTop;

      let target = null;
      if (thumbRect.top < railRect.top) {
        target = offsetWithinRail;
      } else if (thumbRect.bottom > railRect.bottom) {
        target = offsetWithinRail - thumbsEl.clientHeight + thumb.offsetHeight;
      }

      if (target !== null) thumbsEl.scrollTo({ top: target, behavior: 'smooth' });
    };

    const goToSlide = (index) => {
      if (!slides[index]) return;
      setActiveSlide(index);
    };

    const stopAutoplay = () => {
      if (autoplayTimerId !== null) {
        window.clearInterval(autoplayTimerId);
        autoplayTimerId = null;
      }
    };

    const startAutoplay = () => {
      if (slides.length < 2 || prefersReducedMotion) return;
      stopAutoplay();
      autoplayTimerId = window.setInterval(() => {
        goToSlide((activeIndex + 1) % slides.length);
      }, autoplayInterval);
    };

    thumbsEl?.addEventListener('mousedown', (event) => {
      if (event.target.closest('.main-product__gallery-thumb')) event.preventDefault();
    });

    thumbsEl?.addEventListener('click', (event) => {
      const expandBtn = event.target.closest('.main-product__gallery-thumb-expand');
      if (expandBtn) {
        thumbsEl.classList.add('is-expanded');
        return;
      }

      const thumb = event.target.closest('.main-product__gallery-thumb');
      if (!thumb) return;
      goToSlide(thumbButtons.indexOf(thumb));
      startAutoplay();
    });

    gallery.querySelector('.main-product__gallery-dots')?.addEventListener('click', (event) => {
      const dot = event.target.closest('.main-product__gallery-dots-btn');
      if (!dot) return;
      goToSlide(dotButtons.indexOf(dot));
      startAutoplay();
    });

    if (frame && slides.length > 1) {
      const handleSwipeStart = (event) => {
        // Keeps a mouse swipe from highlighting text; the native image drag is blocked site-wide in global.js
        if (!event.touches) event.preventDefault();
        const point = event.touches ? event.touches[0] : event;
        isSwiping = true;
        isHorizontalSwipe = false;
        swipeDeltaX = 0;
        swipeStartX = point.clientX;
        swipeStartY = point.clientY;
        stopAutoplay();
      };

      const handleSwipeMove = (event) => {
        if (!isSwiping) return;

        const point = event.touches ? event.touches[0] : event;
        swipeDeltaX = point.clientX - swipeStartX;
        const deltaY = point.clientY - swipeStartY;

        if (!isHorizontalSwipe && Math.abs(swipeDeltaX) > swipeDirectionLockThreshold && Math.abs(swipeDeltaX) > Math.abs(deltaY)) {
          isHorizontalSwipe = true;
        }

        if (isHorizontalSwipe) event.preventDefault();
      };

      const handleSwipeEnd = () => {
        if (!isSwiping) return;
        isSwiping = false;

        if (isHorizontalSwipe && Math.abs(swipeDeltaX) > swipeThreshold) {
          const nextIndex = swipeDeltaX < 0
            ? (activeIndex + 1) % slides.length
            : (activeIndex - 1 + slides.length) % slides.length;
          goToSlide(nextIndex);
        }

        startAutoplay();
      };

      frame.addEventListener('mousedown', handleSwipeStart);
      frame.addEventListener('mousemove', handleSwipeMove);
      frame.addEventListener('mouseup', handleSwipeEnd);
      frame.addEventListener('mouseleave', handleSwipeEnd);
      frame.addEventListener('touchstart', handleSwipeStart, { passive: true });
      frame.addEventListener('touchmove', handleSwipeMove, { passive: false });
      frame.addEventListener('touchend', handleSwipeEnd, { passive: true });
      frame.addEventListener('touchcancel', handleSwipeEnd, { passive: true });
    }

    // Lets the variant-change handler below jump to a variant's featured media.
    gallery.addEventListener('gallery:select-media', (event) => {
      const index = slides.findIndex((slide) => slide.dataset.mediaId === String(event.detail?.mediaId));
      if (index === -1) return;
      goToSlide(index);
      startAutoplay();
    });

    startAutoplay();
  });

  // When the size changes, move the compact bottle row to an in-stock value before the variant is
  // fetched (capture phase runs ahead of variant-selects), so no sold-out combination is requested.
  document.addEventListener(
    'change',
    (event) => {
      const radio = event.target;
      if (!radio.matches?.('input[type="radio"]')) return;

      const compactRow = radio.closest('variant-selects')?.querySelector('.main-product__pack-row--compact');
      if (!compactRow || compactRow.contains(radio)) return;

      const isUnavailable = (input) => (input.dataset.unavailableSizes || '').split('|').includes(radio.value);
      const checked = compactRow.querySelector('input[type="radio"]:checked');
      if (!checked || !isUnavailable(checked)) return;

      const inStock = [...compactRow.querySelectorAll('input[type="radio"]')].find(
        (input) => input !== checked && !isUnavailable(input)
      );
      if (inStock) inStock.checked = true;
    },
    true
  );

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event?.data?.variant;
    if (variant?.featured_media?.id) {
      document.querySelectorAll('.main-product__gallery').forEach((gallery) => {
        gallery.dispatchEvent(
          new CustomEvent('gallery:select-media', { detail: { mediaId: variant.featured_media.id } })
        );
      });
    }

    // Changing size can land on a sold-out combination (e.g. 1 Litre + Without Bottle). The compact row
    // only lists in-stock values besides the selected one, so move to the first of those.
    if (variant && variant.available === false) {
      window.setTimeout(() => {
        document
          .querySelector('.main-product__pack-row--compact input[type="radio"]:not(:checked)')
          ?.click();
      }, 0);
    }

    const sectionId = event?.data?.sectionId;
    const html = event?.data?.html;
    if (!sectionId || !html) return;

    const button = document.querySelector(`#ProductSubmitButton-${sectionId}.main-product__atc-btn`);
    const contentEl = button?.querySelector('.main-product__atc-btn-content');
    const sourceContentEl = html
      .getElementById(`ProductSubmitButton-${sectionId}`)
      ?.querySelector('.main-product__atc-btn-content');
    if (!button || !contentEl || !sourceContentEl) return;

    if (variant) button.dataset.priceCents = variant.price;
    contentEl.innerHTML = sourceContentEl.innerHTML;
    document.dispatchEvent(new CustomEvent('addon-total:refresh'));
  });
});
